module.exports = __webpack_public_path__ + "img/01_gov3_bc_symbol.a514aab7.svg";